import createLucideIcon from '../createLucideIcon';

/**
 * @component @name MemoryStick
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJ2LTIiIC8+CiAgPHBhdGggZD0iTTEyIDE4di0yIiAvPgogIDxwYXRoIGQ9Ik0xNiAxMnYtMiIgLz4KICA8cGF0aCBkPSJNMTYgMTh2LTIiIC8+CiAgPHBhdGggZD0iTTIgMTFoMS41IiAvPgogIDxwYXRoIGQ9Ik0yMCAxOHYtMiIgLz4KICA8cGF0aCBkPSJNMjAuNSAxMUgyMiIgLz4KICA8cGF0aCBkPSJNNCAxOHYtMiIgLz4KICA8cGF0aCBkPSJNOCAxMnYtMiIgLz4KICA8cGF0aCBkPSJNOCAxOHYtMiIgLz4KICA8cmVjdCB4PSIyIiB5PSI2IiB3aWR0aD0iMjAiIGhlaWdodD0iMTAiIHJ4PSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/memory-stick
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MemoryStick = createLucideIcon('memory-stick', [
  ['path', { d: 'M12 12v-2', key: 'fwoke6' }],
  ['path', { d: 'M12 18v-2', key: 'qj6yno' }],
  ['path', { d: 'M16 12v-2', key: 'heuere' }],
  ['path', { d: 'M16 18v-2', key: 's1ct0w' }],
  ['path', { d: 'M2 11h1.5', key: '15p63e' }],
  ['path', { d: 'M20 18v-2', key: '12ehxp' }],
  ['path', { d: 'M20.5 11H22', key: 'khsy7a' }],
  ['path', { d: 'M4 18v-2', key: '1c3oqr' }],
  ['path', { d: 'M8 12v-2', key: '1mwtfd' }],
  ['path', { d: 'M8 18v-2', key: 'qcmpov' }],
  ['rect', { x: '2', y: '6', width: '20', height: '10', rx: '2', key: '1qcswk' }],
]);

export default MemoryStick;
